import { FieldArray, FormikProps } from "formik";
import React, { useEffect, useState } from "react";
import { RiDeleteBin5Line } from "react-icons/ri";
import { useNavigate } from "react-router-dom";
import ATMLoadingButton from "src/components/UI/atoms/ATMLoadingButton/ATMLoadingButton";
// import ATMMultiSelect from "src/components/UI/atoms/formFields/ATMMultiSelect/ATMMultiSelect";
import ATMSelect from "src/components/UI/atoms/formFields/ATMSelect/ATMSelect";
import ATMTextArea from "src/components/UI/atoms/formFields/ATMTextArea/ATMTextArea";
import ATMTextField from "src/components/UI/atoms/formFields/ATMTextField/ATMTextField";
// import useCourse from "src/hooks/useCourse";
// import useCourseType from "src/hooks/useCourseType";
// import useFaculty from "src/hooks/useFaculty";
// import useLevels from "src/hooks/useLevels";
// import useModes from "src/hooks/useMode";
import usePaymentModes from "src/hooks/usePaymentModes";
// import useSubjects from "src/hooks/useSubject";
import { OfflineOrderFormValues } from "src/models/OfflineOrder.model";
// import { getInputHeight } from "src/utils/formUtils/getInputHeight";
import { handleValidNumber } from "src/utils/validations/numberInput";
// import { GrFormAdd } from "react-icons/gr";
import useAttempt from "src/hooks/useAttempt";
// import { setIsOpenAddSubjectDialog } from "src/redux/slices/SubjectSlice";
import { useDispatch, useSelector } from "react-redux";
// import AddSubjectWrapper from "src/screens/Subject/Add/AddSubjectWrapper";
// import { RootState } from "src/redux/store";
// import AddFacultyWrapper from "src/screens/Faculty/Add/AddFacultyWrapper";
// import { setIsOpenAddDialog as setIsOpenAddFacultyDialog } from "src/redux/slices/FacultySlice";
// import useFranchise from "src/hooks/useFrachise";
import { useGetAdvancePaymentMutation } from "src/services/OfflineOrderService";
import {
  handleValidDecimalNumber,
  handleValidNumber2,
} from "src/utils/formUtils/ValidNumber";
import { showToast } from "src/utils/showToaster";
import useProduct from "src/hooks/useProduct";
import ATMTable, {
  columnTypes,
} from "src/components/UI/atoms/ATMTable/ATMTable";
import ATMMenu from "src/components/UI/atoms/ATMMenu/ATMMenu";
import PaymentModel from "../PaymentModel/PaymentModel";
import ATMDatePicker from "src/components/UI/atoms/formFields/ATMDatePicker/ATMDatePicker";
import moment from "moment";
// import { PiNumberEightThin } from "react-icons/pi";

type Props = {
  formikProps: FormikProps<OfflineOrderFormValues>;
  onlineMode: any;
};
export const regIndiaPhone = RegExp(/^[0]?[6789]\d{9}$/);

const OfflineOrderForm = ({ formikProps, onlineMode }: Props) => {
  const { values, setFieldValue, isSubmitting, handleBlur } = formikProps;
  const [advancedAmount, setAdvancedAmount] = useState(0);
  const [selectedItems, setSelectedItems] = useState<any[]>([]);
  const [remainingFees, setRemainingFees] = useState<string>("");
  const [getAvancePayments, advancePaymentInfo] =
    useGetAdvancePaymentMutation();
  useEffect(() => {
    if (!advancePaymentInfo?.isLoading && advancePaymentInfo?.data) {
      showToast(
        "success",
        `Rs. ${advancePaymentInfo?.data?.data} is available`
      );
      setAdvancedAmount(advancePaymentInfo?.data?.data);
      setFieldValue("totalAdvancePayment", advancePaymentInfo?.data?.data);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [advancePaymentInfo.isLoading]);

  const { product, isDataLoading } = useProduct();
  const [mobileForAdv, setMobileForAdv] = useState("");

  const [settleAdvancePayment, setSettleAdvancePayment] =
    useState<boolean>(false);
  useEffect(() => {
    const totalAmount = values.orderTotal;
    const advancePayment = values.totalAdvancePayment;
    const receivedAmount = values.receivedAmt;
    const courierCharges = values.courierCharges;

    let discountAmount = 0;
    if (values.discountType.value === "FLAT") {
      discountAmount = values.discount || 0;
    } else if (values.discountType.value === "PERCENTAGE") {
      discountAmount = (Number(totalAmount) * Number(values.discount)) / 100;
    }

    const settleAmount =
      Number(totalAmount) +
      Number(courierCharges) -
      advancePayment -
      Number(receivedAmount) -
      discountAmount;
    setRemainingFees(settleAmount.toLocaleString());
    setFieldValue("remainingFees", settleAmount);
  }, [
    values.orderTotal,
    values.totalAdvancePayment,
    values.discount,
    values.courierCharges,
    values.receivedAmt,
    values.discountType, // Make sure to include discountType in dependencies
  ]);

  useEffect(() => {
    const orderTotal = values?.paymentMode.reduce(
      (total: any, payment: any) => {
        // Convert the 'amount' property to a number before summing
        return total + Number(payment.amount);
      },
      0
    );
    setFieldValue("amountPaid", Number(orderTotal) || 0);
    const calculateorderTotal = orderTotal - Number(values?.advanceAmount);
  }, [values?.totalFees, values?.receivedAmt]);

  useEffect(() => {
    let amountPaid = Number(values?.totalFees) - Number(values?.advanceAmount);
    setFieldValue("receivedAmt", amountPaid || 0);
  }, [values?.totalFees, values?.advanceAmount, values?.orderTotal]);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const ProductTypeOptions = product?.map((product: any) => ({
    label: product?.title,
    value: product?._id,
  }));

  const getVariantOptions = (productId: any) => {
    const selectedProduct = product?.find(
      (p: any) => p._id === productId?.value
    );
    return (
      selectedProduct?.variants.map((variant: any) => ({
        label: variant.mode,
        value: variant._id,
      })) || []
    );
  };

  const handleAdd = (index: number) => {
    const item = values.products[index];

    const selectedProduct = product.find(
      (p: any) => p._id === item.productId?.value
    );
    const selectedVariant = selectedProduct?.variants.find(
      (v: any) => v._id === item.variantId?.value
    );

    if (selectedProduct && selectedVariant && item.quantity > 0) {
      // Create books array with all books marked as isIssued: false initially
      const books =
        selectedProduct.books?.map((book: any) => ({
          _id: book?.bookId,
          title: book?.bookName,
          isIssued: false, // Default all books to not issued
        })) || [];

      // Add to selectedItems for display
      const newSelectedItem = {
        _id: Date.now(),
        product: selectedProduct.title,
        productId: item.productId?.value || item.productId,
        variantId: item.variantId?.value || item.variantId,
        variant: selectedVariant.mode,
        price: selectedVariant.price,
        quantity: item.quantity,
        books,
      };

      setSelectedItems((prev) => [...prev, newSelectedItem]);

      // Initialize in bookIssued FieldArray with all books (isIssued: false)
      const initialBookIssued =
        selectedProduct.books?.map((book: any) => ({
          bookId: book?.bookId,
          isIssued: false,
        })) || [];

      setFieldValue("bookIssued", [
        ...values.bookIssued,
        {
          productId: newSelectedItem.productId,
          variantId: newSelectedItem.variantId,
          quantity: newSelectedItem.quantity,
          bookIssued: initialBookIssued, // Initialize with all books
        },
      ]);

      // Calculate and set total amount
      const newTotal =
        selectedItems.reduce(
          (acc, item) => acc + item.price * item.quantity,
          0
        ) +
        selectedVariant.price * item.quantity;
      setFieldValue("orderTotal", newTotal);

      // Reset current fields to blank
      setFieldValue(`products[${index}].productId`, "");
      setFieldValue(`products[${index}].variantId`, "");
      setFieldValue(`products[${index}].quantity`, "");
    }
  };

  const handleDeleteProduct = (id: number) => {
    // Find the item being deleted
    const itemToDelete = selectedItems.find((item) => item._id === id);

    setSelectedItems((prev) => {
      const newItems = prev.filter((item) => item._id !== id);
      // Update total amount
      const newTotal = newItems.reduce(
        (acc, item) => acc + item.price * item.quantity,
        0
      );
      setFieldValue("orderTotal", newTotal);
      return newItems;
    });

    // Remove corresponding entry from bookIssued
    if (itemToDelete) {
      setFieldValue(
        "bookIssued",
        values.bookIssued.filter(
          (bi) =>
            !(
              bi.productId === itemToDelete.productId &&
              bi.variantId === itemToDelete.variantId
            )
        )
      );
    }
  };

  const columns: columnTypes[] = [
    { field: "product", headerName: "Product", flex: "flex-[1.5_1.5_0%]" },
    { field: "variant", headerName: "Variant", flex: "flex-[1.5_1.5_0%]" },
    { field: "price", headerName: "Price", flex: "flex-[1.5_1.5_0%]" },
    { field: "quantity", headerName: "Quantity", flex: "flex-[1_1_0%]" },
    {
      field: "action",
      headerName: "Actions",
      flex: "flex-[1_1_0%]",
      renderCell: (row: any) => (
        <ATMMenu
          options={[
            {
              label: "Delete",
              onClick: () => handleDeleteProduct(row._id),
            },
          ]}
        />
      ),
    },
  ];
  const { attempt } = useAttempt();

  const AttemptOptions = attempt?.map((attempt: any) => {
    return {
      label: attempt?.attempt,
      value: attempt?._id,
    };
  });

  const UserTypeOptions = [
    {
      label: "Student",
      value: "STUDENT",
    },
    {
      label: "Franchise",
      value: "FRANCHISE",
    },
  ];
  const DiscountTypeOptions = [
    { label: "None", value: "NONE" },
    {
      label: "Flat",
      value: "FLAT",
    },
    {
      label: "Percent (%)",
      value: "PERCENTAGE",
    },
  ];
  const DeliveryOptions = [
    {
      label: "PICKUP",
      value: "PICKUP",
    },
    {
      label: "HOME DELIVERY",
      value: "HOME_DELIVERY",
    },
  ];
  return (
    <>
      <div className="p-4">
        <p className="border-l-4 p-2 border-purple-500 font-bold text-xl ">
          Student Details :-{" "}
        </p>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 my-6">
          <div>
            <ATMTextField
              name="name"
              value={values?.name}
              required
              onChange={(e) => {
                setFieldValue("name", e.target.value);
              }}
              label="Name"
              onBlur={handleBlur}
              placeholder="Please enter name"
            />
          </div>
          <div>
            <ATMTextField
              name="email"
              value={values?.email}
              required
              onChange={(e) => {
                setFieldValue("email", e.target.value);
              }}
              label="Email"
              placeholder="Please enter email"
              // onBlur={handleBlur}
            />
          </div>
          <div>
            <ATMTextField
              name="mobile"
              value={values?.mobile}
              maxLength={10}
              required
              onChange={(e) => {
                handleValidNumber2(e) &&
                  setFieldValue("mobile", e.target.value);
              }}
              label="Mobile"
              onBlur={handleBlur}
              placeholder="Please enter number"
            />
          </div>
          <div>
            <ATMSelect
              name="attemptDue"
              placeholder="Attempt Due"
              label="Attempt Due"
              options={AttemptOptions}
              onChange={(newValue: any) => {
                setFieldValue("attemptDue", newValue);
              }}
              value={values?.attemptDue}
            />
          </div>
          <div>
            <ATMSelect
              name="userType"
              required
              placeholder="User Type"
              label="User Type "
              options={UserTypeOptions}
              onChange={(newValue: any) => {
                setFieldValue("userType", newValue);
              }}
              value={values?.userType}
            />
          </div>
          <div>
            <ATMTextField
              name="croNumber"
              value={values?.croNumber}
              onChange={(e) => {
                setFieldValue("croNumber", e.target.value);
              }}
              label="CRO Number"
              onBlur={handleBlur}
              placeholder="Please enter CRO number"
            />
          </div>
        </div>
        <p className="border-l-4 p-2 border-purple-500 font-bold text-xl">
          Product Details :-
        </p>
        <FieldArray name="products">
          {({ push, remove }) => (
            <div>
              {values.products?.map((item, index) => {
                const variantOptions = getVariantOptions(item?.productId);

                return (
                  <div
                    key={index}
                    className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 my-6"
                  >
                    <ATMSelect
                      name={`products[${index}].productId`}
                      label="Product"
                      options={ProductTypeOptions}
                      value={item.productId}
                      onChange={(newValue: string) => {
                        setFieldValue(`products[${index}].productId`, newValue);
                        setFieldValue(`products[${index}].variantId`, "");
                      }}
                    />

                    <ATMSelect
                      name={`products[${index}].variantId`}
                      label="Variant"
                      options={variantOptions}
                      value={item.variantId}
                      onChange={(newValue: string) => {
                        setFieldValue(`products[${index}].variantId`, newValue);
                      }}
                      disabled={!item.productId}
                    />

                    <ATMTextField
                      name={`products[${index}].quantity`}
                      label="Quantity"
                      value={item.quantity || ""}
                      onChange={(e: any) =>
                        setFieldValue(
                          `products[${index}].quantity`,
                          Number(e.target.value)
                        )
                      }
                      placeholder="Enter Quantity"
                      type="number"
                    />

                    <ATMLoadingButton
                      type="button"
                      className="mt-6"
                      onClick={() => handleAdd(index)}
                      disabled={
                        !item.productId || !item.variantId || !item.quantity
                      }
                    >
                      Add to List
                    </ATMLoadingButton>
                  </div>
                );
              })}
            </div>
          )}
        </FieldArray>
        <ATMTable columns={columns} rows={selectedItems} />
        {/* Total Price */}
        <div className="text-right mt-4 font-bold text-lg">
          Total Price: ₹{values?.orderTotal || 0}
        </div>
        <div className="my-6">
          <p className=" text-md underline font-bold">Books Issued</p>
          <FieldArray name="bookIssued">
            {({ push, remove }) => (
              <div className="mt-8">
                {selectedItems?.map((item) => {
                  const bookIssueIndex = values.bookIssued.findIndex(
                    (bi) =>
                      bi.productId === item.productId &&
                      bi.variantId === item.variantId
                  );
                  if (bookIssueIndex === -1) return null;

                  return (
                    <div key={item._id} className="">
                      <div className="grid grid-cols-1">
                        {item.books?.length > 0
                          ? item.books.map((book: any) => {
                              // Find book in bookIssued array (if exists)
                              const bookIssuedEntry = values.bookIssued[
                                bookIssueIndex
                              ]?.bookIssued?.find(
                                (bi: any) => bi.bookId === book._id
                              );

                              // Default to false if book not found in bookIssued array
                              const isChecked = bookIssuedEntry
                                ? bookIssuedEntry.isIssued
                                : false;

                              return (
                                <div
                                  key={book._id}
                                  className="flex items-center gap-2 p-2 border rounded"
                                >
                                  <input
                                    type="checkbox"
                                    checked={isChecked}
                                    onChange={(e) => {
                                      let currentBookIssued = [
                                        ...(values.bookIssued[bookIssueIndex]
                                          ?.bookIssued || []),
                                      ];

                                      if (e.target.checked) {
                                        // Add or update book entry with isIssued: true
                                        if (!bookIssuedEntry) {
                                          currentBookIssued.push({
                                            bookId: book._id,
                                            isIssued: true,
                                          });
                                        } else {
                                          currentBookIssued =
                                            currentBookIssued.map((bi) =>
                                              bi.bookId === book._id
                                                ? { ...bi, isIssued: true }
                                                : bi
                                            );
                                        }
                                      } else {
                                        // Add or update book entry with isIssued: false
                                        if (!bookIssuedEntry) {
                                          currentBookIssued.push({
                                            bookId: book._id,
                                            isIssued: false,
                                          });
                                        } else {
                                          currentBookIssued =
                                            currentBookIssued.map((bi) =>
                                              bi.bookId === book._id
                                                ? { ...bi, isIssued: false }
                                                : bi
                                            );
                                        }
                                      }

                                      setFieldValue(
                                        `bookIssued[${bookIssueIndex}].bookIssued`,
                                        currentBookIssued
                                      );
                                    }}
                                    className="h-4 w-4"
                                  />
                                  <span>{book?.title}</span>
                                </div>
                              );
                            })
                          : null}
                      </div>
                    </div>
                  );
                })}
              </div>
            )}
          </FieldArray>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 my-6">
          <div>
            <ATMSelect
              name="deliveryOption"
              required
              placeholder="Delivery Option"
              label="Delivery Option"
              options={DeliveryOptions}
              onChange={(newValue: any) => {
                setFieldValue("deliveryOption", newValue);
              }}
              value={values?.deliveryOption}
            />
          </div>
          {values?.deliveryOption?.value === "HOME_DELIVERY" ? (
            <>
              <div>
                <ATMTextField
                  name="city"
                  value={values?.city}
                  onChange={(e) => {
                    setFieldValue("city", e.target.value);
                  }}
                  label="City"
                  placeholder="Please enter city"
                />
              </div>
              <div>
                <ATMTextField
                  name="state"
                  value={values?.state}
                  onChange={(e) => {
                    setFieldValue("state", e.target.value);
                  }}
                  label="State"
                  placeholder="Please enter state"
                />
              </div>
              <div>
                <ATMTextField
                  name="pincode"
                  value={values?.pincode}
                  onChange={(e) => {
                    setFieldValue("pincode", e.target.value);
                  }}
                  label="Pincode"
                  placeholder="Please enter pincode"
                />
              </div>
              <div>
                <ATMTextField
                  name="courierCharges"
                  value={values?.courierCharges}
                  onChange={(e) => {
                    handleValidDecimalNumber(e) &&
                      setFieldValue("courierCharges", e.target.value);
                  }}
                  label="Courier charges"
                  placeholder="Please enter courier charges"
                />
              </div>
            </>
          ) : null}
        </div>
        {values?.deliveryOption?.value === "HOME_DELIVERY" ? (
          <>
            <div>
              <ATMTextArea
                name="address"
                value={values?.address}
                onChange={(e) => {
                  setFieldValue("address", e);
                }}
                label="Address"
                placeholder="Please enter address"
              />
            </div>
          </>
        ) : null}
        <div>
          <p className="border-l-4 p-2 mt-5 border-purple-500 font-bold text-xl ">
            Discount :-{" "}
          </p>
          <div className="grid grid-cols-1 gap-3 md:grid-cols-3">
            <div className="">
              <ATMSelect
                name="discountType"
                required
                placeholder="Select discount Option"
                label="Discount Type"
                options={DiscountTypeOptions}
                onChange={(newValue: any) => {
                  setFieldValue("discountType", newValue);
                }}
                value={values?.discountType}
              />
            </div>
            <div>
              <ATMTextField
                name="discount"
                value={values.discount}
                onChange={(e) =>
                  handleValidDecimalNumber(e) &&
                  setFieldValue("discount", e.target.value)
                }
                label="Discount Amount"
                placeholder="Enter Discount Amount"
                onBlur={handleBlur}
              />
            </div>
          </div>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-4 my-5">
          <p className="border-l-4 p-2 mt-5 border-purple-500 font-bold text-xl ">
            Payment Details :-{" "}
          </p>
          <p
            className=" text-md text-blue-500 underline my-4 font-bold"
            onClick={() => setSettleAdvancePayment(true)}
          >
            Settle Advance Payment
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4  my-6">
          {settleAdvancePayment ? (
            <>
              <div>
                <div className="flex gap-2 items-center">
                  <ATMTextField
                    placeholder="Please enter Mobile Number"
                    name="mobileForAdv"
                    value={mobileForAdv}
                    onChange={(e) => {
                      handleValidNumber(e) && setMobileForAdv(e.target.value);
                    }}
                    label="Search Advance Payment"
                    onBlur={handleBlur}
                  />
                  <div className="mt-5">
                    <ATMLoadingButton
                      className="w-fit "
                      disabled={!mobileForAdv.match(regIndiaPhone)}
                      onClick={() => {
                        getAvancePayments({
                          mobile: mobileForAdv,
                        });
                        setFieldValue(`adjustAgainstMobile`, mobileForAdv);
                      }}
                      isLoading={advancePaymentInfo?.isLoading}
                    >
                      Search
                    </ATMLoadingButton>
                  </div>
                </div>
                <span>
                  <span className="text-sm font-medium">
                    Total Advance Amount
                  </span>{" "}
                  : &#8377;{advancedAmount || 0}
                </span>
              </div>
            </>
          ) : null}
        </div>
        <span className="grid grid-cols-1 md:grid-cols-3 gap-4">
          <div>
            <ATMTextField
              name="receivedAmt"
              value={values?.receivedAmt}
              onChange={(e) =>
                handleValidDecimalNumber(e) &&
                setFieldValue("receivedAmt", e.target.value)
              }
              label="received Amount"
              placeholder="Enter received Amount"
              onBlur={handleBlur}
            />
          </div>
          <div>
            <ATMTextField
              name="remainingFees"
              value={remainingFees}
              onChange={(e) => {
                setFieldValue("remainingFees", e.target.value);
              }}
              label="Remaning fees"
              onBlur={handleBlur}
              disabled
            />
          </div>
          <ATMDatePicker
            label="Due Date "
            name="duedate"
            format="DD/MM/YYYY"
            minDate={moment().format("yyyy-MM-DD")}
            value={values.duedate || null}
            onChange={(newValue) =>
              setFieldValue("duedate", moment(newValue)?.format("yyyy-MM-DD"))
            }
          />
        </span>
        <div>
          <PaymentModel formikProps={formikProps} onlineMode={onlineMode} />
        </div>
        <div className="mt-5">
          <ATMTextArea
            name="remark"
            value={values?.remark}
            onChange={(e) => {
              setFieldValue("remark", e);
            }}
            label="Remark"
            placeholder="Please enter remark"
          />
        </div>
      </div>

      <div className="flex justify-end mt-2 px-3 gap-2">
        <ATMLoadingButton
          className="w-24  bg-red-500 font-medium"
          type="button"
          onClick={() => navigate("/offline-order")}
        >
          Cancel
        </ATMLoadingButton>
        <ATMLoadingButton
          className="w-24 "
          isLoading={isSubmitting}
          type="submit"
        >
          Save
        </ATMLoadingButton>
      </div>
    </>
  );
};

export default OfflineOrderForm;
